import { Button, type MantineThemeComponents, rem, Text } from "@mantine/core";

import { tokens } from "../tokens";

export const components: MantineThemeComponents = {
  // Mantine 6 rendered input descriptions and errors as divs; Mantine 7 renders `p`, which cannot hold
  // the block content some call sites pass (a DateDisplay under a Radio). Restored for every input.
  InputDescription: { defaultProps: { component: "div" } },
  InputError: { defaultProps: { component: "div" } },
  Text: Text.extend({
    // Mantine 6 set the root line-height from the size key's token, or from the raw size when it is not
    // a key; with no size it left Mantine's default. Mantine 7 reads the same value from `--text-lh`.
    vars: (theme, { size }) => {
      const textLineHeights: Partial<Record<string, string>> = theme.other.textLineHeights;
      return { root: { "--text-lh": size === undefined ? undefined : (textLineHeights[size] ?? String(size)) } };
    },
  }),
  Button: Button.extend({
    /**
     * these style overrides are ONLY for outline buttons that don't have a defined color prop.
     * the downside to this strategy is that it's mixing direct css with the Mantine theme, and
     * should be consolidated to make this clearer
     *
     * @TODO create a common button component that makes this styling explicit
     */
    vars: (_theme, { color, variant }) => ({
      root:
        variant === "outline" && !color
          ? { "--button-bd": `${rem(1)} solid ${tokens.color.border.default}`, "--button-color": tokens.color.content.secondary }
          : {},
    }),
  }),
};
